"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Canvas = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Div = _interopRequireDefault(require("../Div"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = exports.Wrapper = (0, _styledComponents["default"])(_Div["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  min-width: ", ";\n  min-height: ", ";\n"])), function (_ref) {
  var width = _ref.width;
  return width || '100%';
}, function (_ref2) {
  var height = _ref2.height;
  return height || '100%';
});
var Canvas = exports.Canvas = _styledComponents["default"].canvas(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));